<!--
 * @Author: xh
 * @Description: 雷达图
 * @Date: 2021-11-08 09:46:00
 * @LastEditTime: 2021-11-08 17:47:38
 * @FilePath: \eec-mobile\src\components\echaars\RadarMap.vue
-->
<template>
  <div
    class="className"
    id="multipleBarsLines1"
    style="width:100%;height:440px;padding: 0;"
  ></div>
</template>
<script>
import echarts from "echarts";
export default {
  name: "RadarMap",
  props: ["chartsData"],
  watch: {
    chartsData: {
      handler(newVal) {
        let analysis = newVal.analysis.value;
        let target = newVal.target.value;
        let indevaval = newVal.indevaval.value;
        let names = [];
        if (newVal.names.length > 0) {
          newVal.names.forEach(item => {
            names.push({
              name: item,
              max: 1
            });
          });
        } else {
          names = [{}];
        }
        this.initChart1(analysis, target, indevaval, names);
      },
      deep: true
    }
  },
  data() {
    return {
      chart: null,
      actual: [],
      target: [],
      indicator: []
    };
  },
  methods: {
    breakStr(str) {
      const n = str.length / 5;
      let receiver = "";
      for (var i = 0; i < n; i++) {
        receiver += str.slice(i * 5, (i + 1) * 5) + "\n";
      }
      console.log("receiver: ", receiver);
      return receiver;
    },
    initChart1(analysis, target, indevaval, names) {
      this.chart = echarts.init(document.getElementById("multipleBarsLines1"));
      var option = {
        // toolbox: {
        //   show: true,
        //   right: 0,
        //   feature: {
        //     saveAsImage: {
        //       show: true
        //     }
        //   }
        // },
        tooltip: {},
        legend: {
          data: ["直接达成值", "间接达成值", "期望达成值"],
          bottom: 0,
          textStyle: {
            color: "#aaa"
          }
        },
        radar: {
          // shape: 'circle',
          // indicator: names.filter(item => {
          //   return [
          //     {
          //       name:
          //         item.name.slice(0, 6) +
          //         "\n" +
          //         "\n" +
          //         item.name.slice(6, item.length - 1),
          //       max: 1
          //     }
          //   ];
          // }),
          indicator: names,
          radius: 90
        },
        series: [
          {
            type: "radar",
            data: [
              {
                value: analysis,
                name: "直接达成值",
                itemStyle: {
                  normal: {
                    color: "#7c8282", // 图表中各个图区域的颜色
                    areaStyle: {
                      type: "default",
                      opacity: 0.1, // 图表中各个图区域的透明度
                      color: "#7c8282" // 图表中各个图区域的颜色
                    }
                  }
                }
              },
              {
                value: indevaval,
                name: "间接达成值",
                itemStyle: {
                  normal: {
                    color: "#FFA351", // 图表中各个图区域的颜色
                    areaStyle: {
                      type: "default",
                      opacity: 0.1, // 图表中各个图区域的透明度
                      color: "#FFA351" // 图表中各个图区域的颜色
                    }
                  }
                }
              },
              {
                value: target,
                name: "期望达成值",
                itemStyle: {
                  normal: {
                    color: "#5AB3FF", // 图表中各个图区域的颜色
                    areaStyle: {
                      type: "default",
                      opacity: 0.1, // 图表中各个图区域的透明度
                      color: "#5AB3FF" // 图表中各个图区域的颜色
                    }
                  }
                }
              }
            ]
          }
        ]
      };
      this.chart.setOption(option);
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.className {
  margin-bottom: 30px;
}
</style>
